(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('crm-referral-source', {
                parent: 'entity',
                url: '/crm-referral-source',
                data: {
                    authorities: [],
                    pageTitle: 'CrmReferralSources'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/crm-referral-source/crm-referral-sources.html',
                        controller: 'CrmReferralSourceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE, access);
                }]

            })
            .state('crm-referral-source-detail.edit', {
                parent: 'crm-referral-source-detail',
                url: '/detail/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-referral-source/crm-referral-source-dialog.html',
                            controller: 'CrmReferralSourceDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmReferralSource', function (CrmReferralSource) {
                                    return CrmReferralSource.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('^', {}, {reload: false});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('crm-referral-source.new', {
                parent: 'crm-referral-source',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-referral-source/crm-referral-source-dialog.html',
                            controller: 'CrmReferralSourceDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        name: null,
                                        description: null,
                                        website: null,
                                        preferred: null,
                                        inNetwork: null,
                                        address1: null,
                                        address2: null,
                                        zipCode: null,
                                        primaryContact: null,
                                        phone: null,
                                        status: null,
                                        id: null,
                                        corporation: CoreService.getCorporation()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-referral-source', null, {reload: 'crm-referral-source'});
                        }, function () {
                            $state.go('crm-referral-source');
                        });
                    }
                }]
            })
            .state('crm-referral-source.edit', {
                parent: 'crm-referral-source',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-referral-source/crm-referral-source-dialog.html',
                            controller: 'CrmReferralSourceDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmReferralSource', function (CrmReferralSource) {
                                    return CrmReferralSource.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-referral-source', null, {reload: 'crm-referral-source'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('crm-referral-source.delete', {
                parent: 'crm-referral-source',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-referral-source/crm-referral-source-delete-dialog.html',
                            controller: 'CrmReferralSourceDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmReferralSource', function (CrmReferralSource) {
                                    return CrmReferralSource.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-referral-source', null, {reload: 'crm-referral-source'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();
